import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  navItems: Array<{
    id: string;
    label: string;
    icon: React.ElementType;
  }>;
  activeItem: string;
  setActiveItem: (id: string) => void;
}
export const MobileNav: React.FC<MobileNavProps> = ({
  isOpen,
  onClose,
  navItems,
  activeItem,
  setActiveItem
}) => {
  return <AnimatePresence data-id="element-568">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="fixed inset-0 bg-black/30 backdrop-blur-sm md:hidden z-40" data-id="element-569" />
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} className="fixed bottom-0 inset-x-0 bg-white rounded-t-2xl shadow-2xl md:hidden z-50" data-id="element-570">
            <div className="relative p-6" data-id="element-571">
              <div className="absolute left-1/2 -translate-x-1/2 -top-3 w-12 h-1.5 bg-gray-300 rounded-full" data-id="element-572" />
              <button onClick={onClose} className="absolute right-5 top-5 p-2 hover:bg-gray-50 rounded-full transition-colors" data-id="element-573">
                <XIcon className="h-5 w-5 text-gray-500" data-id="element-574" />
              </button>
              <nav className="mt-8 space-y-2" data-id="element-575">
                {navItems.map(item => {
              const Icon = item.icon;
              return <button key={item.id} onClick={() => {
                setActiveItem(item.id);
                onClose();
              }} className={`flex items-center w-full px-4 py-3.5 rounded-xl text-sm font-medium transition-all ${activeItem === item.id ? 'bg-[#1E90FF]/10 text-[#1E90FF] shadow-sm' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-576">
                      <Icon className="h-5 w-5 mr-3" data-id="element-577" />
                      {item.label}
                    </button>;
            })}
              </nav>
              <div className="mt-8 space-y-3 px-1" data-id="element-578">
                <button onClick={() => {
              console.log('Exporting report as PDF...');
              onClose();
            }} className="flex items-center justify-center w-full py-3 space-x-2 bg-white border-2 border-[#1E90FF] text-[#1E90FF] rounded-xl font-medium hover:bg-[#1E90FF]/5 transition-colors" data-id="element-579">
                  <span data-id="element-580">Export report</span>
                </button>
                <a href="https://brandpulse-analytics.com/create" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full py-3 bg-[#1E90FF] text-white rounded-xl font-medium hover:bg-[#1E90FF]/90 transition-colors" onClick={onClose} data-id="element-581">
                  Create new test
                </a>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
};